import React, { useState, useMemo, useEffect, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Navbar from '../../../components/comm/Navbar';
import Header from '../../../components/comm/Head';
import style from './HealthInfoMain.module.css';
import URL from '../../../constants/url';
import axiosApi from '../../../api/daonAxios';
import HealthInfoDetail from './HealthInfoDetail';
import { getPatntHealthStatus } from '../../../utils/patnt'

// const MAIN_TABS = [
//     { key: 'custom', label: '맞춤형' },
//     { key: 'bookmark', label: '즐겨찾기' },
//     { key: 'all', label: '전체' },
// ];

const MAIN_TABS = [
    {value : 'C', label : '맞춤형'},
    {value : 'B', label : '즐겨찾기'},
    {value : 'A', label : '전체'} 
];

const HealthInfoMain = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [category, setCategory] = useState('');
    const tabBarRef = useRef(null);
    const [indicatorStyle, setIndicatorStyle] = useState({});
    const [bookmarks, setBookmarks] = useState();
    const [detailId, setDetailId] = useState(null);

    const justOpenedRef = useRef(false);

    const toggleBookmark = (id) => {
        setBookmarks(prev =>
            prev.includes(id) ? prev.filter(v => v !== id) : [...prev, id]
        );
    };

    //////////////////////////////////////

    const [ctgryList ,setCtgryList] = useState([]);

    const [contentList, setContentList] = useState([]);

    const [searchObj, setSearchObj] = useState({
        customized : 'C',
        ctgry : ''
    });

    const handleChangeTab = (newValue) => {
        setSearchObj({...searchObj, customized : newValue});
    };

    const handleCtgry = (newValue) => {
        setSearchObj({...searchObj, ctgry : newValue});
    };

    const getCategory = async () => {

        const jToken = localStorage.getItem("jToken");

        const requestOption = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        };

        await axiosApi.get('/healthContent/category',requestOption)
        .then((res) => {
            const list = res.data.result;
            list.unshift({ctgryCd : '', ctgryCdNm:'전체'});
            setCtgryList(list);
        })
        .catch(error => {
            console.error(error);
        }).finally(() => {
            // setIsLoading(false);
        })
    }

    useEffect(() => {
        getCategory();
    },[])

    useEffect(() => {

        if (location.state?.detailOpen) {
            justOpenedRef.current = false;   // state 반영 완료
            return;
        }
        if (justOpenedRef.current) return;   // 아직 반영 전이면 무시


        // 뒤로가기로 state 가 사라지면 팝업 닫기
        if (detailId !== null && !location.state?.detailOpen) {
            setDetailId(null);
            getContentListRef.current?.();
        }
    }, [location.state, detailId]);

    const getContentList = useCallback(() => {

        const jToken = localStorage.getItem("jToken");

        const loginUser = JSON.parse(sessionStorage.getItem('loginUser'));

        const usrHsptlMap = loginUser.usrHsptlMap;

        const dissAt = loginUser.usrHsptlMap.find((a) => a.cnncHsptlCd === "012").dissAt;
        const hhprsDgnssAt = loginUser.usrHsptlMap.find((a) => a.cnncHsptlCd === "012").hhprsDgnssAt;
        const dabtsDgnssAt = loginUser.usrHsptlMap.find((a) => a.cnncHsptlCd === "012").dabtsDgnssAt;

        const stauts = getPatntHealthStatus(dissAt, dabtsDgnssAt, hhprsDgnssAt);

        const requestOptions = {
            params : {
                ctgry : searchObj.ctgry,
                status : stauts
            },
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }
        // setIsLoading(true);
        axiosApi.get(`/healthContent/list/${searchObj.customized}`,requestOptions)
        .then((res) => {
            setContentList(res.data.result);
        })
        .catch(error => {
            console.error(error);
        }).finally(()=> {
            // setIsLoading(false);
        })
    }, [searchObj])

    useEffect(() => {
        getContentList();
    },[searchObj]);

    const handleCheckBkmk = (e, contId, bkmkId) => {
        const jToken = localStorage.getItem("jToken");

        const requestOptions = {
            headers: {
                "Authorization": `Bearer ${jToken}`,
            },
        }

        const params = {
            cntsId : contId,
            bkmkId : bkmkId,
            useAt : e.target.checked ? '1' : '0',
            patntId : "123"
        };
        axiosApi.post('/healthContent/bookmark',params, requestOptions)
        .then((res) => {
            getContentList();
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
        })
    }

    ////////////////////
    const updateIndicator = (key) => {
        const bar = tabBarRef.current;
        if (!bar) return;
        const btn = bar.querySelector(`[data-tab="${key}"]`);
        if (!btn) return;
        setIndicatorStyle({ left: btn.offsetLeft, width: btn.offsetWidth });
    };

    useEffect(() => { updateIndicator(searchObj.customized); }, [searchObj.customized]);
    useEffect(() => {
        const onResize = () => updateIndicator(searchObj.customized);
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
    }, [searchObj.customized]);

    const handleClickContent = (id, imgUrl) => {
        // navigate(`${URL.HEALTH_INFORM_DETAIL}`, { state: { id : id, imgUrl: imgUrl } });
        justOpenedRef.current = true;
        setDetailId(id);
        navigate(location.pathname + location.search, { state: { detailOpen: true } })
    }

    const getContentListRef = useRef(null);
    getContentListRef.current = getContentList;

    const handleCloseDetail = useCallback(() => {
        navigate(-1);
    }, [navigate]);

    return (
        <>
            <Header menu="healthInform" />
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap" data-top-padding="0">

                    {/* ── 메인 탭 ── */}
                    <div className={style.tabBar} ref={tabBarRef}>
                        {MAIN_TABS.map(tab => (
                            <button
                                key={tab.value}
                                className={`${style.tabItem} ${searchObj.customized === tab.value ? style.active : ''}`}
                                data-tab={tab.value}
                                onClick={() => handleChangeTab(tab.value)}
                            >
                                {tab.label}
                            </button>
                        ))}
                        <span className={style.tabIndicator} style={indicatorStyle} />
                    </div>

                    {/* ── 카테고리 탭 ── */}
                    <div className={style.categoryBar}>
                        <div className={style.categoryScroll}>
                            {ctgryList.map(cat => (
                                <button
                                    key={cat.ctgryCd}
                                    className={`${style.categoryBtn} ${searchObj.ctgry === cat.ctgryCd ? style.categoryActive : ''}`}
                                    onClick={() => handleCtgry(cat.ctgryCd)}
                                >
                                    {cat.ctgryCdNm}
                                </button>
                            ))}
                        </div>
                    </div>
{/* {contentList.length > 0 ? contentList.map((cont, idx) => { */}
                    {/* ── 콘텐츠 리스트 ── */}
                    {contentList.length > 0 ? (
                        <ul className={style.contentList}>
                            {contentList.map(cont => (
                                <li key={cont.id} className={style.contentItem}>
                                    <div className={style.contentBody} onClick={() => handleClickContent(cont.id, cont.cntsImgUrl)}>
                                        <div className={style.thumbWrap}>
                                            <img src={cont.cntsThumbUrl} alt="" draggable={false} />
                                        </div>
                                        <div className={style.textWrap}>
                                            <p className={style.contentTitle}>{cont.cntsSj}</p>
                                            <span className={style.contentTags}>{cont.ctgrys}</span>
                                        </div>
                                    </div>
                                    <div className={style.bookmarkWrap}>
                                        <input
                                            type="checkbox"
                                            id={`bkmk_${cont.id}`}
                                            checked={cont.bkmkUseAt === '1' ? true : false}
                                            onChange={(e) => {
                                                handleCheckBkmk(e, cont.id, cont.bkmkId)
                                            }}
                                        />
                                        <label htmlFor={`bkmk_${cont.id}`} />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className={style.empty}>
                            <p>데이터가 없습니다.</p>
                        </div>
                    )}

                </div>
            </div>
            <Navbar />

            {detailId !== null && (
                <HealthInfoDetail contId={detailId} onClose={handleCloseDetail} />
            )}
        </>
    );
};

export default HealthInfoMain;
